// extracted by mini-css-extract-plugin
export default {"vacancyCreateWrapper":"applicationFormCreate_vacancyCreateWrapper__a2nvw"};